import type { RGBColor } from "react-color";
export const colorConvert = (color: RGBColor): string => {
  if (!color) return `rgba(249, 220, 230, 0.8)`;
  return `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`;
};
